module.exports = __webpack_public_path__ + "static/OG_Image-5583e1947b2e61a1f20d684182e8fb1a.png";